import { Separator, View, YStack } from 'tamagui';

import { Shadows } from '../../components/Shadows';
import {
    BodyLargeRegular,
    BodyMediumRegular,
    MonoBodyMediumRegular,
} from '../../components/text/Typography';

const ShadowPreview = ({
    title,
    shadowStyle,
}: {
    title: string;
    shadowStyle: object;
}) => {
    return (
        <YStack gap={8}>
            <BodyLargeRegular>{title}</BodyLargeRegular>
            <View
                backgroundColor="$white"
                borderRadius={12}
                padding={16}
                borderWidth={1}
                borderColor="$gray300"
                minHeight={80}
                justifyContent="center"
                {...shadowStyle}
            >
                <MonoBodyMediumRegular color="$gray1000">
                    {`<View {...Shadows.${title}} />`}
                </MonoBodyMediumRegular>
            </View>
        </YStack>
    );
};

export const ShadowsGallery = () => {
    return (
        <YStack gap={16}>
            <BodyMediumRegular marginBottom={16}>
                Standard shadow tokens used across Smoothie components.
            </BodyMediumRegular>
            <ShadowPreview title="SMALL" shadowStyle={Shadows.SMALL} />
            <ShadowPreview title="MEDIUM" shadowStyle={Shadows.MEDIUM} />
            <ShadowPreview title="LARGE" shadowStyle={Shadows.LARGE} />
            <ShadowPreview
                title="CONVERSATIONAL"
                shadowStyle={Shadows.CONVERSATIONAL}
            />
            <Separator marginVertical={32} />
            <ShadowPreview
                title="RING_SMALL"
                shadowStyle={Shadows.RING_SMALL}
            />

            <ShadowPreview title="RING" shadowStyle={Shadows.RING} />
            <ShadowPreview
                title="RING_ACTIVE"
                shadowStyle={Shadows.RING_ACTIVE}
            />
        </YStack>
    );
};
